/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChatControllerGetHistoryQueryResponse, ChatControllerGetHistoryPathParams, ChatControllerGetHistoryQueryParams, ChatControllerGetHistory401, ChatControllerGetHistory403 } from "../../models/chatController/ChatControllerGetHistory";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { chatControllerGetHistory } from "../../clients/chatService/chatControllerGetHistory";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const chatControllerGetHistoryQueryKey = (scopeId: ChatControllerGetHistoryPathParams["scopeId"], params: ChatControllerGetHistoryQueryParams = {}) => [{
  url: '/api/v1/chat/history/:scopeId',
  params: {
    scopeId: scopeId
  }
}, ...(params ? [params] : [])] as const;
export type ChatControllerGetHistoryQueryKey = ReturnType<typeof chatControllerGetHistoryQueryKey>;
export function chatControllerGetHistoryQueryOptions(scopeId: ChatControllerGetHistoryPathParams["scopeId"], params?: ChatControllerGetHistoryQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = chatControllerGetHistoryQueryKey(scopeId, params);
  return queryOptions<ChatControllerGetHistoryQueryResponse, ResponseErrorConfig<ChatControllerGetHistory401 | ChatControllerGetHistory403>, ChatControllerGetHistoryQueryResponse, typeof queryKey>({
    enabled: !!scopeId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return chatControllerGetHistory(scopeId, params, config);
    }
  });
}

/**
 * @summary Get chat history for a scope
 * {@link /api/v1/chat/history/:scopeId}
 */
export function useChatControllerGetHistory<TData = ChatControllerGetHistoryQueryResponse, TQueryData = ChatControllerGetHistoryQueryResponse, TQueryKey extends QueryKey = ChatControllerGetHistoryQueryKey>(scopeId: ChatControllerGetHistoryPathParams["scopeId"], params?: ChatControllerGetHistoryQueryParams, options: {
  query?: Partial<QueryObserverOptions<ChatControllerGetHistoryQueryResponse, ResponseErrorConfig<ChatControllerGetHistory401 | ChatControllerGetHistory403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? chatControllerGetHistoryQueryKey(scopeId, params);
  const query = useQuery({
    ...chatControllerGetHistoryQueryOptions(scopeId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ChatControllerGetHistory401 | ChatControllerGetHistory403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}